angular.module('shared').directive('waiverEzidebitCreditCardPaymentDetails', function() {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      walletDetails: '=',
      publicKey: '=',
      pageParams: '=',
      saveWaiver: '&'
    },
    template: require('templates/shared/waivers/payment_details/waiver_ezidebit_credit_card.html.slim'),
    controller: ["$scope", "$rootScope", "$timeout", "$document", "CreditCardValidationService", "CreditCardExpirationDatesService", "loadingAnimation", "EzidebitService", function($scope, $rootScope, $timeout, $document, CreditCardValidationService, CreditCardExpirationDatesService, loadingAnimation, EzidebitService) {
      var endpoint, getCardDetails, init, initSaveCustomer, initUpdateCustomer, isCustomerExist, onError, onSaveSuccess, onUpdateSuccess, ref, ref1, signedWaiverWalletDetail;
      endpoint = $scope.waiver.ezidebit_public_url;
      $scope.transliterate = EzidebitService.transliterate;
      $scope.years = CreditCardExpirationDatesService.getYears();
      $scope.months = CreditCardExpirationDatesService.getMonths();
      signedWaiverWalletDetail = $scope.waiver.signed_waiver_wallet_detail_attributes;
      isCustomerExist = signedWaiverWalletDetail.customer_ref && signedWaiverWalletDetail.active_on_ezidebit;
      $scope.customerReference = EzidebitService.getCustomerReference({
        gymId: ((ref = $rootScope.gym) != null ? ref.id : void 0) || window.DATA.gym_id,
        contactId: (ref1 = $scope.waiver.signed_waiver_contacts_attributes[0]) != null ? ref1.contact_id : void 0,
        context: 'SW'
      });
      initSaveCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'SaveCustomer',
            submitButton: 'submitCreditCard',
            submitCallback: onSaveSuccess,
            submitError: onError,
            customerFirstName: 'firstName',
            customerLastName: 'lastName',
            nameOnCard: 'nameOnCard',
            cardNumber: 'cardNumber',
            cardExpiryMonth: 'expiryMonth',
            cardExpiryYear: 'expiryYear',
            customerEmail: 'customerEmail',
            customerMobile: 'customerMobile',
            customerReference: 'customerReference'
          };
          window.initEziDebit();
          return eziDebit.init($scope.publicKey, params, endpoint);
        });
      };
      initUpdateCustomer = function() {
        return $timeout(function() {
          var params;
          params = {
            submitAction: 'ChangeCustomerPaymentInfo',
            submitButton: 'updateCreditCard',
            submitCallback: onUpdateSuccess,
            submitError: onError,
            nameOnCard: 'nameOnCard',
            cardNumber: 'cardNumber',
            cardExpiryMonth: 'expiryMonth',
            cardExpiryYear: 'expiryYear',
            customerRef: 'customerRef'
          };
          window.initEziDebit();
          return eziDebit.init($scope.publicKey, params, endpoint);
        });
      };
      init = function() {
        if (isCustomerExist) {
          return initUpdateCustomer();
        } else {
          return initSaveCustomer();
        }
      };
      $scope.$watch('publicKey', function(key) {
        if (key) {
          return init();
        }
      });
      onSaveSuccess = function(response) {
        $scope.walletDetails.error = void 0;
        $scope.waiver.signed_waiver_wallet_detail_attributes = angular.extend($scope.waiver.signed_waiver_wallet_detail_attributes, getCardDetails(), {
          customer_ref: response.Data.CustomerRef
        });
        return $scope.saveWaiver();
      };
      onUpdateSuccess = function(response) {
        $scope.walletDetails.error = void 0;
        $scope.waiver.signed_waiver_wallet_detail_attributes = angular.extend($scope.waiver.signed_waiver_wallet_detail_attributes, getCardDetails());
        return $scope.saveWaiver();
      };
      getCardDetails = function() {
        return {
          payment_method: 'credit_card',
          payment_provider: 'ezidebit',
          last4: $scope.walletDetails.cardNumber.substr(-4),
          full_name: $scope.walletDetails.nameOnCard,
          exp_month: $scope.walletDetails.expiryMonth,
          exp_year: $scope.walletDetails.expiryYear,
          bsb: void 0
        };
      };
      onError = function(error) {
        return $timeout(function() {
          $scope.pageParams.isLoading = false;
          loadingAnimation.hide();
          $scope.walletDetails.error = error;
          return $document.scrollToElementAnimated(angular.element('#walletDetails'));
        });
      };
      $scope.checkCardNumber = function() {
        var ref2;
        $scope.walletDetails.cardNumber = (ref2 = $scope.walletDetails.cardNumber) != null ? ref2.replace(/[^0-9]/g, '') : void 0;
        return $scope.walletDetails.cardValid = CreditCardValidationService.check($scope.walletDetails.cardNumber);
      };
      return $scope.cardholderNameValid = function() {
        return CreditCardValidationService.nameValid($scope.walletDetails.nameOnCard);
      };
    }]
  };
});
